// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notFound {
    padding: 80px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/LSR/participant/participant-study-not-found/participant-study-not-found.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB","sourcesContent":[".notFound {\r\n    padding: 80px 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
